import { create } from "zustand";
import { gameStatusEnum, orderAllowedListByGameState, Role, RoleCode } from "../../configs/constants";
import { GameSession } from "../../services/game_service";

export interface AllowedState {
    orderByAgent: gameStatusEnum[] | []
    orderByStaff: gameStatusEnum[] | []
    orderByOwner: gameStatusEnum[] | []
}

interface GameSessionState {
    currentGameSession: GameSession | null | undefined;
    setCurrentGameSession: (game: GameSession | null | undefined) => void;
    allowedByState: AllowedState | null | undefined;
    setAllowedByState: (allowedState: AllowedState) => void;
    checkCanCreateOrderByGameState: (role: RoleCode | undefined | null, game: GameSession | undefined | null) => boolean;
}

export const gameSessionState = create<GameSessionState>((set) => ({
    currentGameSession: undefined,
    setCurrentGameSession: (currentGameSession) => set({ currentGameSession }),
    allowedByState: { orderByAgent: [], orderByStaff: [], orderByOwner: [] },
    setAllowedByState: (allowedByState) => set({ allowedByState }),
    checkCanCreateOrderByGameState: (role: RoleCode | undefined | null, game: GameSession | undefined | null) => {
        if (!game) return false;

        if (role === RoleCode.OWNER) return orderAllowedListByGameState.orderByOwner.includes(game.state);
        else if (role === RoleCode.STAFF) return orderAllowedListByGameState.orderByStaff.includes(game.state);
        else if (role === RoleCode.AGENT) return orderAllowedListByGameState.orderByAgent.includes(game.state);
        else return false;
    },
}));
